import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { AsyncPaginate } from 'react-select-async-paginate'
import { useLocation } from 'react-router-dom'

import { cms } from '../../../helper'
import { setNotification } from '../../../Redux/Reducers/notificationHandling'
import { request } from '../../../Redux/Sagas/requests/api'
import './roundedInput.scss'
import { primary_color } from '../../../Helper/uiHelper'
import { getDependDataPayload } from '../../../CMSComponent/Forms/Fields/select'
import usePrevious from '../../../CustomHook/usePrevious'

const checkIsFieldRequired = (data) => {
  if (data?.field_id === 'item_type_id') {
    return false
  } else {
    return true
  }
}

const RoundedSelect = ({
  onChange,
  field_id,
  validationError,
  setValidationError,
  search_keyword_exclude = [],
  search_limit_error = 'Please search proper keyword',
  setFormFieldValue,
  formFieldValue = {},
  data,
  parentData,
  form,
  setFormData,
  formIndex,
  depend_field_source_table,
  parentRequired = true,
  hideLabel,
  isClearable,
}) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const parent_id = searchParams.get('parent_id') || parentData?.id

  const dependent_value = formFieldValue?.[data?.component_call_data_connection?.source_field]
  const currentItemDateTimeId = formFieldValue?.item_date_time_id
  const shouldRefreshOnItemDateTimeChange = data?.component_call_data_connection?.data === 'category.blocks'

  const [paginationData, setPaginationData] = useState({
    pageNo: 1,
    hasMore: true,
  })
  const [selectedOption, setSelectedOption] = useState()
  const prev_dependent_value = usePrevious(dependent_value)
  const prevItemDateTimeId = usePrevious(currentItemDateTimeId)
  useEffect(() => {
    if (data?.component_call_data_connection.component_name === 'dependent_data') {
      if (prev_dependent_value !== dependent_value && prev_dependent_value) {
        setSelectedOption(null)
        setFormData((prevFormsData) => {
          return prevFormsData.map((item, i) => {
            if (formIndex === i) {
              let newdata = {
                ...item,
              }
              newdata[data?.field_id] = null
              return newdata
            } else {
              return item
            }
          })
        })
        setPaginationData({
          pageNo: 1,
          hasMore: true,
        })
      }
    }
  }, [dependent_value])

  useEffect(() => {
    if (!shouldRefreshOnItemDateTimeChange) return
    if (!prevItemDateTimeId || prevItemDateTimeId === currentItemDateTimeId) return

    const previousBlockName = formFieldValue?.[`${data?.field_id}_label`] || selectedOption?.label

    setSelectedOption(null)
    setPaginationData({
      pageNo: 1,
      hasMore: true,
    })
    setFormData((prevFormsData) => {
      return prevFormsData.map((item, i) => {
        if (formIndex === i) {
          return {
            ...item,
            [data?.field_id]: null,
            [`${data?.field_id}_label`]: null,
            item_id: null,
            item_id_label: null,
          }
        }
        return item
      })
    })

    loadOptions(undefined, undefined, { forcePage: 1, updatePagination: false }).then((res) => {
      if (!previousBlockName) return
      const normalizedPreviousBlockName = `${previousBlockName}`.trim().toLowerCase()
      const matchedBlock = res?.options?.find((option) => `${option?.label}`.trim().toLowerCase() === normalizedPreviousBlockName)
      if (matchedBlock) {
        onChangeValue(matchedBlock)
      }
    })
  }, [currentItemDateTimeId])
  useEffect(() => {
    if (data?.cms_key === 'field.year_session' && !formFieldValue[data?.field_id]) {
      loadOptions().then((res) => {
        if (res && res.options) {
          onChangeValue(res?.options[0])
          setSelectedOption(res?.options[0])

          setPaginationData({
            pageNo: 1,
            hasMore: true,
          })
        }
      })
    }
  }, [])
  useEffect(() => {
    if (selectedOption?.value !== formFieldValue[data?.field_id] && formFieldValue[data?.field_id]) {
      let label = formFieldValue[`${data?.field_id}_label`] || formFieldValue[data?.field_id]
      setSelectedOption({ label: label, value: formFieldValue[data?.field_id] })
    } else if (selectedOption?.value !== formFieldValue[data?.field_id] && !formFieldValue[data?.field_id]) {
      setSelectedOption(null)
    }
  }, [JSON.stringify(formFieldValue)])

  useEffect(() => {
    if (data?.field_id === 'item_date_time_id' && formFieldValue?.isNew) {
      const topParentTableRowId = parent_id ? parseInt(parent_id) : undefined
      const showOffDisplay = data?.component_call_data_connection?.show_off_display
      request('get-template-data', 'POST', {
        page: 1,
        fields: 'id,name',
        source_table: 'item_date_times',
        ...(topParentTableRowId ? { top_parent_table_row_id: topParentTableRowId } : {}),
        top_parent_table: 'domains',
        ...(showOffDisplay !== undefined ? { show_off_display: showOffDisplay } : {}),
      }).then((res) => {
        if (res?.data?.data?.data?.[0]) {
          setFormData((prevFormsData) => {
            return prevFormsData.map((item, i) => {
              if (formIndex === i) {
                let newdata = {
                  ...item,
                }
                newdata[data?.field_id] = res?.data?.data?.data?.[0]?.id
                newdata[`${data?.field_id}_label`] = res?.data?.data?.data?.[0]?.title

                return newdata
              } else {
                return item
              }
            })
          })
          setSelectedOption({ value: res?.data?.data?.data?.[0]?.id, label: res?.data?.data?.data?.[0]?.title })
        }
      })
    }
  }, [])

  const onChangeValue = (selectedValue) => {
    if (validationError && setValidationError) setValidationError(false)
    // let updatedValue = {
    //   ...formFieldValue,
    // }
    // updatedValue[data?.field_id] = selectedValue?.value
    // setFormFieldValue(updatedValue)
    setFormData((prevFormsData) => {
      return prevFormsData.map((item, i) => {
        if (formIndex === i) {
          let newdata = {
            ...item,
          }
          newdata[data?.field_id] = selectedValue?.value
          newdata[`${data?.field_id}_label`] = selectedValue?.label
          if (data?.field_id === 'query_type_id') {
            newdata['query_id'] = null
          }
          if (data?.field_id === 'item_date_time_id' && data?.clear_related_fields_on_change !== false) {
            newdata['category_id'] = null
            newdata['location_id'] = null
            newdata['item_id'] = null
          }
          return newdata
        } else {
          return item
        }
      })
    })
    setSelectedOption(selectedValue)
  }

  async function loadOptions(search, loadedOptions, config = {}) {
    const urlShowOff = searchParams.get('show_off_display') === 'true' || searchParams.get('is_admin') === 'true'
    const showOffDisplay =
      data?.component_call_data_connection?.show_off_display !== undefined
        ? data?.component_call_data_connection?.show_off_display
        : urlShowOff
        ? true
        : undefined
    const pageNo = config?.forcePage || (paginationData?.pageNo ? paginationData?.pageNo : 1)
    let payload = {
      page: pageNo,
      fields: data?.component_call_data_connection?.fields,
      // columns: [data?.field_id],
      // uuid: form?.uuid
      source_table: data?.component_call_data_connection?.source_table,
      ...(showOffDisplay !== undefined ? { show_off_display: showOffDisplay } : {}),
    }
    const parent_required = ['location_id']
    if (parentRequired) {
      let parentid
      if (parentData?.id) {
        parentid = parseInt(parentData?.id)
      }
      payload = {
        ...payload,
        top_parent_table_row_id: parentid,
        // top_parent_table: 'domains',
      }
    }

    if (data?.component_call_data_connection.component_name === 'dependent_data') {
      if (!dependent_value) {
        // dispatch(setNotification({ type: 'error', message: 'Please select Student Year Group first.' }))
        return {
          options: [],
          hasMore: false,
        }
      }
      let depend_payload = getDependDataPayload(
        form?.component_call_fields,
        data?.component_call_data_connection,
        dependent_value,
        depend_field_source_table
      )

      payload = {
        ...payload,
        ...depend_payload,
      }
    }
    if (formFieldValue?.item_date_time_id) {
      payload = {
        ...payload,
        item_date_time_id: formFieldValue.item_date_time_id,
      }
    }

    const response = await request('get-template-data', 'POST', { ...payload })
    const options = response?.data?.data?.data?.map((item) => {
      if (item?.active) {
        setSelectedOption({
          value: item?.id,
          label: item?.name,
        })
      }
      return {
        value: item?.id,
        label: item?.name,
      }
    })
    if (config?.updatePagination !== false) {
      setPaginationData({
        pageNo: response?.data?.data?.current_page + 1,
        hasMore: !response?.data?.data?.next_page_url ? false : true,
      })
    }
    return {
      options: options,
      hasMore: !response?.data?.data?.next_page_url ? false : true,
    }
  }

  if (data?.field_id === 'item_type_id' && !formFieldValue?.previous_locker_maintenance) return
  return (
    <>
      {!hideLabel && (
        <div className='body2' style={{ color: primary_color, marginBlock: '2rem 0.65rem' }}>
          {data?.cms_key && cms(data?.cms_key)}
        </div>
      )}

      <div className='rounded-select form-select' id='validationCustom04' required>
        <AsyncPaginate
          value={selectedOption ? selectedOption : null}
          loadOptions={loadOptions}
          isSearchable={false}
          onChange={(val) => onChangeValue(val)}
          cacheUniqs={
            shouldRefreshOnItemDateTimeChange
              ? [dependent_value, formFieldValue?.item_date_time_id]
              : [dependent_value]
          }
          classNamePrefix='rounded-select'
          styles={{
            menu: (base) => ({ ...base, zIndex: 15 }),
            control: (baseStyles, state) => ({
              ...baseStyles,
              borderRadius: '50px',
              borderColor: validationError && !selectedOption ? 'red' : baseStyles.borderColor,
            }),
            placeholder: (baseStyles, state) => ({
              ...baseStyles,
              color: validationError && !selectedOption ? 'red' : 'rgba(0, 0, 0, 0.2)',
            }),
          }}
          isDisabled={data?.component_call_data_connection.component_name === 'dependent_data' && !dependent_value}
          // isMulti={true}
          placeholder={data?.place_holder || 'Select option'}
          isClearable={isClearable}
        />
      </div>
      {validationError && checkIsFieldRequired(data) && !selectedOption ? (
        <div className=' text-danger subtitle1 mt-1'>This field is required.</div>
      ) : (
        <></>
      )}
      {data?.cms_sub_heading ? <div className=' mt-2 ml-1'>{data?.cms_sub_heading}</div> : <></>}
    </>
  )
}

export default RoundedSelect
